module.exports = __webpack_public_path__ + "img/23.eec5b852.png";